<template>
  <div>
    <navbarVue />
    <router-view></router-view>
    <whatsApp class="z-100 fixed bottom-5 right-5" />
    <section class="hidden md:block w-full bg-sky-900 h-[50px]"></section>
  </div>
</template>

<script>
import feather from 'feather-icons'

import navbarVue from '@/components/navbar/navbar.vue'
import whatsApp from '@/components/whatsApp.vue'
export default {
  name: 'App',
  components: {
    navbarVue,
    whatsApp,
  },
  mounted() {
    feather.replace()
    this.scrollToTop()

  },

  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  },
}
</script>

<style></style>
